'use client'

import Link from 'next/link'
import React, { useState } from 'react'

import CustomImage from '@/components/common/CustomImage'
import { useImageZoom } from '@/hooks/useImageZoom'
import { cn } from '@/lib/utils'

type ZoomImageProps = {
  src: string
  alt?: string
  children?: React.ReactNode
  href: string
  imageScale?: number
  imageClassName?: string
}

export default function ZoomImage({ href, src, alt = 'image', children, imageScale = 1.5, imageClassName }: ZoomImageProps) {
  const [imageSize, setImageSize] = useState({ width: 0, height: 0 })
  const { zoomPosition, handleMouseMove, handleMouseLeave, scale } = useImageZoom(imageScale)

  return (
    <div className="image relative" onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave}>
      <Link href={href} target="_blank">
        <CustomImage
          src={src}
          fallbackSrc="/assets/images/no-image.png"
          alt={alt}
          width={0}
          height={0}
          sizes="100vw"
          className={cn('max-h-[200px] aspect-square w-full h-auto rounded-tl-[5px] rounded-tr-[5px]', imageClassName)}
          onLoad={(e) => {
            const img = e.currentTarget
            setImageSize({ width: img.width, height: img.height })
          }}
        />
      </Link>
      {children}

      {/* Hiển thị lớp zoom nếu visible */}
      {zoomPosition.visible && (
        <div
          className="fixed z-[100] border border-bordercolor shadow-border pointer-events-none"
          style={{
            top: `${zoomPosition.y}px`,
            left: `${zoomPosition.x}px`,
            width: `${imageSize.width * scale}px`,
            height: `${imageSize.height * scale}px`,
            backgroundImage: `url(${src})`,
            backgroundSize: `${imageSize.width * scale}px ${imageSize.height * scale}px`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            opacity: zoomPosition.visible ? 1 : 0,
            transform: `scale(${zoomPosition.visible ? 1 : 0.95})`,
          }}
        />
      )}
    </div>
  )
}
